import CopyableEditing from './copyable-editing';
import { Plugin } from '@ckeditor/ckeditor5-core';
import './styles.css';
class CopyableUI extends Plugin {
    init() { }
}
export default class Copyable extends Plugin {
    static get requires() {
        return [CopyableEditing, CopyableUI];
    }
}
